import { LocationView } from '@img-arena/consoles-api-streaming'
import { toPercentage } from '@/components/HistoricalStatistics/utils'
import { Column, COLUMN_CELL_TYPE } from '@/components/table/base'
import { COUNTRIES } from '@/constants/regions'
import { secondsToHMS } from '@/utils/secondsToHMS'

export const COUNTRIES_VIEWS_COLUMNS: Column<LocationView>[] = [
  {
    id: 'location',
    label: 'Country',
    type: COLUMN_CELL_TYPE.TEXT,
    transform: (value) =>
      COUNTRIES.find((country) => country.iso2 === value.toLowerCase())?.name || '',
    sortAttribute: 'location'
  },
  {
    id: 'totalViews',
    label: 'Total Views',
    type: COLUMN_CELL_TYPE.TEXT,
    sortAttribute: 'totalViews'
  },
  {
    id: 'percentageViews',
    label: 'Percentage Views',
    type: COLUMN_CELL_TYPE.TEXT,
    transform: toPercentage,
    sortAttribute: 'percentageViews'
  },
  {
    id: 'averageDuration',
    label: 'Average Duration',
    type: COLUMN_CELL_TYPE.TEXT,
    transform: (value) => secondsToHMS(value),
    sortAttribute: 'averageDuration'
  }
]
